import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'icon']

  toggle(event) {
    event.preventDefault()

    const isExpanded = this.contentTarget.classList.contains('expanded')

    this.closeAllCards()

    if (isExpanded) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    this.contentTarget.classList.add('expanded')
    this.contentTarget.style.maxHeight = '500px'
    this.contentTarget.style.marginTop = '1.5rem'
    this.contentTarget.style.opacity = '1'
    this.iconTarget.textContent = '−'
  }

  collapse() {
    this.contentTarget.classList.remove('expanded')
    this.contentTarget.style.maxHeight = '0'
    this.contentTarget.style.marginTop = '0'
    this.contentTarget.style.opacity = '0'
    this.iconTarget.textContent = '+'
  }

  closeAllCards() {
    const container = this.element.closest('#conditions-container') || this.element.closest('.row')

    if (!container) return

    container.querySelectorAll('[data-condition-card-target="content"]').forEach((content) => {
      if (content !== this.contentTarget) {
        content.classList.remove('expanded')
        content.style.maxHeight = '0'
        content.style.marginTop = '0'
        content.style.opacity = '0'
      }
    })

    container.querySelectorAll('[data-condition-card-target="icon"]').forEach((icon) => {
      if (icon !== this.iconTarget) {
        icon.textContent = '+'
      }
    })
  }
}
